import Vue from "vue";
import Vuex from "vuex";
import { Message } from "element-ui";

Vue.use(Vuex);

let tabIndex = 0; //用于记录入队列的顺序
export default new Vuex.Store({
  state: {
    //一些应用的状态
    appStatus: {
      isPwa: false
    },
    iframeKey: -1,  // iframe的key，用于刷新
    activeTabId: -1,  //当前活动的tab
    interIframeList: [],  //用于内部应用的iframe
    tabs: [
      {
        id: -1,
        name: "企业管理中心-大白身份云服务",
        icon: "../../../../static/app_logo_0628.png",
        src: location.href
      }
    ]
  },
  mutations: {
    // 更新tab
    setTab(state, tabs) {
      state.tabs = tabs;
    },
    // 更新iframe列表
    setInterIframeList(state, interIframeList) {
      state.interIframeList = interIframeList;
    },
    // 更新当前活动的tab
    setActiveTab(state, id) {
      state.activeTabId = id;
    },
    // 更新用于刷新iframe的key
    setIframeKey(state, iframeKey) {
      state.iframeKey = iframeKey;
    },
    //更新应用的一些状态
    setAppStatus(state, data) {
      for(const key of Object.keys(data))
      state.appStatus[key] = data[key];
    }
  },
  getters: {
    curActiveIndex: ({ tabs, activeTabId }) =>
      tabs.findIndex(item => item.id === activeTabId)
  },
  actions: {
    // 新增tab
    addTab({ commit, state }, { data }) {
      const index = state.tabs.findIndex(({ id }) => id === data.id);
      //判断是否是app应用，是的话则用ifame装载，优化打开体验
      if (!~data.src.indexOf('http')) {
        commit("setInterIframeList", [data]);
        commit("setIframeKey", Math.random());
        return;
      }
      if (!~index) {
        const tabs = [...state.tabs];
        data.sort = ++tabIndex;
        if (tabs.length >= 10) {
          Message("标签栏不能超过10个，已删除最开始打开的标签栏");
          // 找到最小下标，就是最早入栈的，然后删除
          let lastIndex;
          tabs.reduce((pre, cur, i) => {
            if (pre > (cur.sort || Infinity)) {
              lastIndex = i;
            }
            return Math.min(pre, cur.sort || Infinity);
          }, Infinity);

          tabs.splice(lastIndex, 1);
        }
        // tabsQueue.push(data.id);
        commit("setTab", [...tabs, data]);
      }
      commit("setActiveTab", data.id);
    },
    // 移除tab
    removeTab({ commit, state, getters }, { removeType, data }) {
      const index = state.tabs.findIndex(({ id }) => id === data.id);

      let tabs = [...state.tabs];
      switch (removeType) {
        case "cloneOne":
          if (~index) tabs.splice(index, 1);
          break;
        case "cloneRight":
          tabs = tabs.filter(({ id }, i) => index >= i || id === -1);
          break;
        case "cloneAll":
          tabs = tabs.filter(({ id }) => [data.id, -1].includes(id));
          break;
      }
      //不同删除情况的下标处理
      if (removeType === "cloneOne") {
        commit("setActiveTab", -1);
      } else if (getters.curActiveIndex >= index && removeType !== "cloneOne") {
        commit("setActiveTab", data.id);
      } else if (getters.curActiveIndex === -1 && removeType) {
        commit("setActiveTab", data.id);
      }
      commit("setTab", tabs);

    }
  }
});
